export default "__VITE_ASSET__B6fCjm56__"